import { render, staticRenderFns } from "./commissioned.vue?vue&type=template&id=9d89d02a&scoped=true"
import script from "./commissioned.vue?vue&type=script&lang=ts"
export * from "./commissioned.vue?vue&type=script&lang=ts"
import style0 from "./commissioned.vue?vue&type=style&index=0&id=9d89d02a&prod&lang=less&scoped=true"
import style1 from "./commissioned.vue?vue&type=style&index=1&id=9d89d02a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d89d02a",
  null
  
)

export default component.exports